import { render, staticRenderFns } from "./receipt-ingress-component.vue?vue&type=template&id=10b724a8&scoped=true&"
import script from "./receipt-ingress-component.vue?vue&type=script&lang=js&"
export * from "./receipt-ingress-component.vue?vue&type=script&lang=js&"
import style0 from "./receipt-ingress-component.vue?vue&type=style&index=0&id=10b724a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b724a8",
  null
  
)

export default component.exports